import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Input from "../../Elements/Form/Input";
import Button from "../../Elements/Button";
import useQuery from "../../../hook/useQuery";
import httpClient from "../../../services/httpClient";
import {productsApi, videoProductApi} from "../../../constans/apiUrls";
import Loading from "../../Elements/Loading/Loading";
import useToastNotify from "../../../hook/useToastNotify";
import {useHistory} from "react-router-dom";
import {ISelectOptionsItem} from "../../../contracts/select_options";
import {
    ClassStatusVideoProduct,
    StatusVideoProduct,
    TypeVideoProduct,
    VideoLinkType
} from "../../../constans/enumTypes";
import {
    generateClassStatusVideoProductTitle,
    generateStatusVideoProductTitle,
    generateTypeVideoProductTitle, generateVideoLinkTypeTitle
} from "../../../helpers/functions";
import InputSelect from "../../Elements/Form/InputSelect";
import InputFile from "../../Elements/Form/InputFile";
import {IVideoProductData} from "../../../contracts/data/video_product";
import {IProductTitleData} from "../../../contracts/data/product";


const InnerVideoProductForm = (props: FormikProps<IVideoProductData>) => {
    const queryParams = useQuery()
    const history = useHistory()
    const {toastNotify} = useToastNotify()
    const [loading, setLoading] = useState<boolean>(true)
    const [loadingProduct, setLoadingProduct] = useState<boolean>(true)
    const typeVideoOptions:Array<ISelectOptionsItem> = [
        {value: TypeVideoProduct.COURSE, label:generateTypeVideoProductTitle(TypeVideoProduct.COURSE)},
        {value: TypeVideoProduct.PRODUCT, label:generateTypeVideoProductTitle(TypeVideoProduct.PRODUCT)},
        {value: TypeVideoProduct.WEBINAR, label:generateTypeVideoProductTitle(TypeVideoProduct.WEBINAR)},
        {value: TypeVideoProduct.FREE, label:generateTypeVideoProductTitle(TypeVideoProduct.FREE)},
    ]
    const statusVideoProductOptions:Array<ISelectOptionsItem> = [
        {value: StatusVideoProduct.DONE, label:generateStatusVideoProductTitle(StatusVideoProduct.DONE)},
        {value: StatusVideoProduct.REGISTERING, label:generateStatusVideoProductTitle(StatusVideoProduct.REGISTERING)},
        {value: StatusVideoProduct.RECORDED, label:generateStatusVideoProductTitle(StatusVideoProduct.RECORDED)},
        {value: StatusVideoProduct.PERFORMING, label:generateStatusVideoProductTitle(StatusVideoProduct.PERFORMING)},
    ]
    const classStatusVideoProductOptions:Array<ISelectOptionsItem> = [
        {value: ClassStatusVideoProduct.DONE, label:generateClassStatusVideoProductTitle(ClassStatusVideoProduct.DONE)},
        {value: ClassStatusVideoProduct.PERFORMING, label:generateClassStatusVideoProductTitle(ClassStatusVideoProduct.PERFORMING)},
    ]
    const typeTrailerOptions:Array<ISelectOptionsItem> = [
        {value: VideoLinkType.LINK, label:generateVideoLinkTypeTitle(VideoLinkType.LINK)},
        {value: VideoLinkType.KAVIMO, label:generateVideoLinkTypeTitle(VideoLinkType.KAVIMO)},
    ]
    const isCounselingOptions:Array<ISelectOptionsItem> = [
        {value: 0, label:'ندارد'},
        {value: 1, label:'دارد'},
    ]
    const [optionsProducts, setOptionsProducts] = React.useState<Array<ISelectOptionsItem>>([])

    const handleFetchPrevData = async () => {
        await httpClient().get(`${videoProductApi.update}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200){
                    props.setValues(response?.data?.data)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    const handleFetchProducts = async () => {
        await httpClient().get(productsApi.list_title)
            .then(response => {
                if (response.status === 200) {
                    const array_option: Array<ISelectOptionsItem> = []
                    response?.data?.map((item: IProductTitleData, _: number) => {
                        array_option.unshift({value: item.id, label: item?.title})
                    })
                    setOptionsProducts(array_option)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoadingProduct(false))
    }

    useEffect(() => {
        handleFetchProducts()
        if(props?.status?.formType === 'edit' && queryParams.get('id')){
            handleFetchPrevData()
        }else {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        if(props?.status?.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
            if(props.status?.result?.status === 'success'){
                history.replace('/dashboard/videos-products/list')
            }
        }
    }, [props.status])

    return (
        <React.Fragment>
            {(loading || loadingProduct) ? <Loading />:
                <Form>
                    <div className={"w-3/5"}>
                        <InputSelect name={'product'} label={'محصول'}
                                     placeholder={'محصول...'}
                                     handleSetValue={(values: any) => props.setFieldValue('product', values)}
                                     options={optionsProducts} isMultiple={false} error={props?.errors?.product}
                                     meta={props.getFieldMeta('product')} isRequired={true}
                                     defaultValue={optionsProducts.find((item, _) => item.value === props.values?.product)}
                        />
                        <InputSelect name={'type_video'} label={'نوع محصول ویدیویی'}
                                     placeholder={'نوع محصول ویدیویی...'}
                                     handleSetValue={(values: any) => props.setFieldValue('type_video', values)}
                                     options={typeVideoOptions} isMultiple={false} error={props?.errors?.type_video}
                                     meta={props.getFieldMeta('type_video')}
                                     defaultValue={typeVideoOptions.find((item, _) => item.value === props.values?.type_video)}
                        />
                        <InputSelect name={'status_product'} label={'وضعیت محصول ویدیویی'}
                                     placeholder={'وضعیت محصول ویدیویی...'}
                                     handleSetValue={(values: any) => props.setFieldValue('status_product', values)}
                                     options={statusVideoProductOptions} isMultiple={false} error={props?.errors?.status_product}
                                     meta={props.getFieldMeta('status_product')}
                                     defaultValue={statusVideoProductOptions.find((item, _) => item.value === props.values?.status_product)}
                        />
                        <Input name={"class_link"} label={"لینک کلاس محصول ویدیویی"} placeholder={"لینک کلاس محصول ویدیویی..."}
                               meta={props.getFieldMeta('class_link')} defaultValue={props.values?.class_link}/>
                        <Input name={"class_help_link"} label={"لینک کمکی کلاس محصول ویدیویی"} placeholder={"لینک کمکی کلاس محصول ویدیویی..."}
                               meta={props.getFieldMeta('class_help_link')} defaultValue={props.values?.class_help_link}/>
                        <InputSelect name={'status_class'} label={'وضعیت کلاس'}
                                     placeholder={'وضعیت محصول ویدیویی...'}
                                     handleSetValue={(values: any) => props.setFieldValue('status_class', values)}
                                     options={classStatusVideoProductOptions} isMultiple={false} error={props?.errors?.status_class}
                                     meta={props.getFieldMeta('status_class')}
                                     defaultValue={classStatusVideoProductOptions.find((item, _) => item.value === props.values?.status_class)}
                        />
                        <InputSelect name={'type_trailer'} label={'نوع لینک تریلر'}
                                     placeholder={'نوع لینک تریلر...'}
                                     handleSetValue={(values: any) => props.setFieldValue('type_trailer', values)}
                                     options={typeTrailerOptions} isMultiple={false} error={props?.errors?.type_trailer}
                                     meta={props.getFieldMeta('type_trailer')}
                                     defaultValue={typeTrailerOptions.find((item, _) => item.value === props.values?.type_trailer)}
                        />
                        <Input name={"trailer_video"} label={"لینک تریلر محصول ویدیویی"} placeholder={"لینک تریلر محصول ویدیویی..."}
                               meta={props.getFieldMeta('trailer_video')} defaultValue={props.values?.trailer_video}/>
                        <Input name={"summary"}  as={'textarea'} label={"خلاصه متن برای محصول ویدیویی"} placeholder={"خلاصه متن برای محصول ویدیویی..."}
                               meta={props.getFieldMeta('summary')} defaultValue={props.values?.summary}/>
                        <Input name={"description"} as={'textarea'} label={"متن برای محصول ویدیویی"} placeholder={"متن برای محصول ویدیویی..."}
                               meta={props.getFieldMeta('description')} defaultValue={props.values?.description}/>
                        <InputSelect name={'is_counseling'} label={'مشاوره برای محصول ویدیویی'}
                                     placeholder={'مشاوره برای محصول ویدیویی...'}
                                     handleSetValue={(values: any) => props.setFieldValue('is_counseling', values === 1)}
                                     options={isCounselingOptions} isMultiple={false} error={props?.errors?.is_counseling} // props?.errors?.type!
                                     meta={props.getFieldMeta('is_counseling')}
                                     defaultValue={isCounselingOptions.find((item, _) => item.value === (props?.values?.is_counseling ? 1 : 0))}
                        />
                        <InputFile name={"banner"} accept={".jpg,.jpeg,.png"} label={"بنر"}
                                   meta={props.getFieldMeta('banner')} isImg handleUploadFile={props.setFieldValue}
                                   defaultValue={props.values?.banner} isRequired
                        />
                    </div>
                    <div className={"text-left"}>
                        <Button title={props.status?.formType === 'create' ? "ثبت محصول ویدیویی جدید" : "بروزرسانی محصول ویدیویی"} isLoading={props.isSubmitting}/>
                    </div>
                </Form>}
        </React.Fragment>
    )
}

export default InnerVideoProductForm